import { DefaultError, useQuery } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import { type Features } from "@/users/v3/features/queries.types";

export const useUserFeaturesQuery = <Data = Features>(
  options?: Omit<
    Parameters<typeof useQuery<Features, DefaultError, Data>>[0],
    "queryKey" | "queryFn"
  >,
) => {
  const query = useQuery<Features, DefaultError, Data>({
    ...options,
    queryKey: [ApiCatalog.feature.key, "me"],
    queryFn: () => api().get(ApiCatalog.feature.endpoint),
  });

  return query;
};

export default useUserFeaturesQuery;
